import devtools from "@vue/devtools";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCompositionApi from "@vue/composition-api";
import VueInputAutowidth from "vue-input-autowidth";
import { auth } from "./firebase.config";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import VueIntercom from "vue-intercom";

import EvaIcons from "vue-eva-icons";
import "@/assets/css/styles.sass";

if (process.env.NODE_ENV === "development") {
  devtools.connect("41.190.30.197", "8000");
} else {
  Sentry.init({
    dsn:
      "https://b545e8d10593442aa6cf2d1648e3d99c@o211046.ingest.sentry.io/1335846",
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
  Vue.use(Sentry);
}

Vue.use(VueCompositionApi);
Vue.use(EvaIcons);
Vue.use(VueInputAutowidth);
Vue.use(VueIntercom, { appId: "g17yrqpq" });

Vue.config.productionTip = false;

let app;

auth.onAuthStateChanged((user) => {
  if (!app) {
    if (user) store.dispatch("getData", user);
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  }
});
